module.exports = __webpack_public_path__ + "static/media/logo-color.da110a99.svg";